<style lang="scss" scoped>
    .training-start-menu {
        height: 40px;
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .dropdown-item {
        font-size: 1.2rem;
        cursor: pointer;
    }

    .start-new-session-menu-item {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
    }
</style>

<template>
    <div class="dropdown training-start-menu">
        <button class="btn btn-orange-blue" href="#" :data-training-id="trainingId" @click="setCurrentTraining" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Start
        </button>
        <div class="dropdown-menu" aria-labelledby="#dropdownMenuLink">
            <div v-for="(session, index) in this.trainingSessionsForMenu"
                :key="session.id"
                class="dropdown-item"
                @click="setCurrentSession(session)"
                data-toggle="modal"
                data-target="#session-modal"
            >
                <a
                @keyup.enter.stop="setCurrentSession(session)"
                tabindex="0"
                >
                    {{ session.title }}
                </a>
            </div>

            <div class="dropdown-divider"></div>

            <div class="dropdown-item">
                <div class="start-new-session-menu-item">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/></svg>
                    <button type="button" class="btn btn-link" @click="handleAddNewSessionButtonClick" data-toggle="modal" data-target="#session-modal">Start New Session</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';

    export default{
        components: {
        },
        props: {
            trainingId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                newSession: true,
            }
        },
        methods: {
            setCurrentSession: function (session) {
                // this.currentSession = session;
                this.setShowAddTrainingSession({showAddTrainingSession: false});
                this.setCurrentTrainingSession({currentTrainingSession: session});
            },
            formatDate: function (value) {
                if (value) {
                    return moment(value).format('MM/DD/YY');
                }
                return "";
            },
            truncateTitle(title, length=30) {
                if(!title) {
                    title = "Unnamed Session";
                }
                if(title.length > length) {
                    return title.substring(0,length) + "...";
                }
                return title;
            },
            setCurrentTraining(event) {
                this.setCurrentTrainingId({currentTrainingId: event.target.dataset.trainingId})
            },
            handleAddNewSessionButtonClick() {
                this.setShowAddTrainingSession({showAddTrainingSession: true});
            },
            ...mapMutations({
                setCurrentTrainingId: 'SET_CURRENT_TRAINING_ID',
                setShowAddTrainingSession: 'SET_SHOW_ADD_TRAINING_SESSION',
                setCurrentTrainingSession: 'SET_CURRENT_TRAINING_SESSION'
            })
        },
        computed: {
            trainingSessionsForMenu: function() {
                return this.trainingSessionsForTraining(this.trainingId).filter((s,i) => {
                    return !s.is_finalized;
                });
            },
            ...mapState([
                'latestQuizResponses',
                'latestEvaluationResponses',
            ]),
            ...mapGetters([
                'trainingSessionsForTraining'
            ]),
        },
        mounted() {
        }
    }
</script>
